import CurrentLightTheme from 'foundations-theming/themes/current/light/theme';
import { useMemo } from 'react';
import { ThemeProvider as StyledComponentsThemeProvider } from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
// This will grow as we start testing additional themes and modes.
// Eventually, in a follow-up PR, we can add support to load themes dynamically instead.
// E.g. https://git.hubteam.com/errodriguez/hds-components-prototypes/blob/master/src/theming-experiment/ExperimentalAppProvider.tsx#L37-L46
const getTheme = (themeName, themeMode) => {
  if (themeName === 'current') {
    if (themeMode === 'light') {
      return CurrentLightTheme;
    }
  }
  throw new Error('Unsupported theme and mode combination.');
};

/**
 * The ThemeProvider provides the theme to your app via the React Context. Foundations
 * components will not work without it. It is used by the `AppProvider` component,
 * which is the top-level component that should wrap your entire app. However it
 * can also be used on its own lower in your component tree if you need to override
 * the theme for a specific subtree for optin user testing purposes.
 *
 * This component is also used by `hs-test-utils` to wrap all unit test component trees.
 */
export const ThemeProvider = ({
  themeName = 'current',
  themeMode = 'light',
  children
}) => {
  // Because this component is used by `hs-test-utils` to wrap all unit test component
  // trees, `React.useState` cannot be used in this component until incorrect usage of
  // spies in tests across our frontend apps is resolved.

  const theme = useMemo(() => getTheme(themeName, themeMode), [themeName, themeMode]);
  return /*#__PURE__*/_jsx(StyledComponentsThemeProvider, {
    theme: theme,
    children: children
  });
};